import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
	isShowBottom: false
}

const mutations = {
	setShowBottom(state, isShow) {
		state.isShowBottom = isShow
	}
}

export default new Vuex.Store({
	state,
	mutations
})
